<template>
  <div
    :class="[{ 'border-sh-primary': selected }, `w-${size}`, `h-${size}`]"
    :style="{ background: `${background}` }"
    :title="label"
    class="relative rounded-full cursor-pointer flex border-2"
  >
    <base-icon
      v-if="selected"
      size="xxs"
      name="check-icon"
      class="absolute text-center pin-r pin-b -mb-1 -mr-1 w-4 h-4 bg-sh-primary-lighten-5 rounded-full text-white"
    />
  </div>
</template>
<script>
export default {
  name: 'Swatch',
  props: {
    label: {
      type: String,
      required: true
    },
    hex: {
      type: [String],
      required: false,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      required: false,
      default: 8
    }
  },
  computed: {
    background() {
      if (null === this.hex) {
        return (
          'conic-gradient(#fff 0.25turn, #000 0.25turn 0.5turn, #fff 0.5turn 0.75turn, #000 0.75turn)' +
          ' top left / 50% 50% repeat'
        );
      }
      return this.hex;
    }
  }
};
</script>
